interface DurationConnectorProps {
    duration: string
}

/**
 * Renders a horizontal line with an arrow and a centered duration label.
 * Used between departure and arrival times on trip cards.
 */
export function DurationConnector({ duration }: DurationConnectorProps) {
    return (
        <div className="flex flex-1 items-center px-3">
            <div className="relative flex w-full items-center">
                <div className="h-px flex-1 bg-[#e2e2e2]" />
                <span className="bg-white px-2 text-xs text-[#767676] italic">{duration}</span>
                <div className="h-px flex-1 bg-[#e2e2e2]" />
                <svg
                    className="ml-0.5 h-2 w-2 shrink-0 text-[#e2e2e2]"
                    viewBox="0 0 8 8"
                    fill="currentColor"
                    aria-hidden="true"
                >
                    <path d="M0 0l8 4-8 4z" />
                </svg>
            </div>
        </div>
    )
}
